import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-left",
  "use": "chevron-left-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"chevron-left\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\" d=\"M19 25c.6.5 1.4.5 2 0 .5-.6.5-1.4 0-2l-7.1-7 7-7a1.3 1.3 0 00-.9-2.3c-.3 0-.7.1-1 .4l-8 8c-.5.5-.5 1.3 0 1.8l8 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol